import FilterTabView from "../../../components/filterTabView/FilterTabView";
import { useEffect, useState } from 'react';
import { projects } from "../../../util/constants/projects";
import { BP } from "../../../util/constants/breakpoints";
import { PROJECTTYPE } from "../../../util/constants/projectTypes";

export default function ProjectList() {

    const [tabTextStyle, setTabTextStyle] = useState({
        fontSize : "14px", //text-base
        letterSpacing : "0.1em", // tracking-wider
        fontWeight: 600, //semibold
    })

    const onWindowWidthChange = () => {
        setTabTextStyle(getTabTextStyle)
    }

    const getTabTextStyle = () => {
        if(window.innerWidth < BP.sm) {
            return {
                fontSize : "14px", //text-base
                letterSpacing : "0.1em", // tracking-wider
                fontWeight: 600, //semibold
            };
        }
        else {
            return {
                fontSize : "16px", //text-base
                letterSpacing : "0.2em", // tracking-wider
                fontWeight: 600, //semibold
            };
        }

    }

    useEffect(() => {
        setTabTextStyle(getTabTextStyle)
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const filterAllProject = (project) => {
        return true;
    }

    const filterFullstackProject = (project) => {
        if(project.type === PROJECTTYPE.FULLSTACK)
            return true;
        else return false;
    }


    const filterFrontEndProject = (project) => {
        if(project.type === PROJECTTYPE.FRONTEND)
            return true;
        else return false;
    }

    // const filterBackEndProject = (project) => {
    //     if(project.type === PROJECTTYPE.BACKEND)
    //         return true;
    //     else return false;
    // }


    // const filterCreativeProject = (project) => {
    //     if(project.type === PROJECTTYPE.CREATIVE)
    //         return true;
    //     else return false;
    // }



    return (
        <>
            <div>
                <FilterTabView
                    // namelist={["ALL", "FULLSTACK", "FRONTEND", "BACKEND"]}
                    namelist={["ALL", "FULLSTACK", "FRONTEND"]}
                    tabTextStyle={tabTextStyle}
                    items={projects}
                    filterCallbacks={[
                        filterAllProject,
                        filterFullstackProject,
                        filterFrontEndProject,
                    ]}
                    // filterCallbacks={[
                    //     filterAllProject,
                    //     filterFullstackProject,
                    //     filterFrontEndProject,
                    //     filterBackEndProject,
                    // ]}
                />

            </div>
        </>
    );
}